/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  HeroContainer,
  HeroContent,
  HeroTitle,
  HeroParagraph,
  HeroSmallScreen,
  Container,
  EarthRound,
  FixtureDiv,
} from "./Hero.styled";

import {
  layer,
  curve,
  line1,
  rectangle1,
  rectangle2,
} from "../../../public/assets";
import Navbar from "../Navbar/Navbar";
import { useTranslation } from "react-i18next";
import { selectLocale } from "../../locales/localeSlice";
import { useSelector } from "react-redux";
import EntranceAnimationY from "../../components/EntranceAnimationY";
import JoinWailist from "../JoinWaitlist/JoinWaitlist.component";
import ConfettiPage from "../ConfettiPage/ConfettiPage.component";
import Anime, { anime } from "react-anime";
import EntranceAnimationX from "../EntranceAnimationX";
import Button from "../Button/Button";

const Hero = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  const [contentIndexOne, setContentIndexOne] = useState(0);
  const [contentIndexTwo, setContentIndexTwo] = useState(0);
  const [contentIndexThree, setContentIndexThree] = useState(0);
  const [isShiftedOne, setIsShiftedOne] = useState(false);
  const [isShiftedTwo, setIsShiftedTwo] = useState(false);
  const [isShiftedThree, setIsShiftedThree] = useState(false);
  const [showWailist, setShowWaitlist] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const contentArrayOne = [
    "GAMING",
    "RETAIL",
    "FASHION",
    "INSURANCE",
    "HEALTHCARE",
  ];
  const contentArrayTwo = [
    "REAL ESTATE",
    "BEAUTY",
    "FOOD",
    "GOVERNMENT",
    "ENTERTAINMENT",
  ];
  const contentArrayThree = [
    "FINANCIAL SERVICES",
    "EDUCATION",
    "HOSPITALITY",
    "TRANSPORTATION",
    "TECHNOLOGY",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsShiftedOne(true);
      setTimeout(() => {
        setContentIndexOne(
          (prevIndex) => (prevIndex + 1) % contentArrayOne.length
        );
        setIsShiftedOne(false);
      }, 1000);
    }, 3000);

    return () => clearInterval(interval);
  }, [contentArrayOne]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsShiftedTwo(true);
      setTimeout(() => {
        setContentIndexTwo(
          (prevIndex) => (prevIndex + 1) % contentArrayTwo.length
        );
        setIsShiftedTwo(false);
      }, 1000);
    }, 3000);

    return () => clearInterval(interval);
  }, [contentArrayTwo]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsShiftedThree(true);
      setTimeout(() => {
        setContentIndexThree(
          (prevIndex) => (prevIndex + 1) % contentArrayThree.length
        );
        setIsShiftedThree(false);
      }, 1000);
    }, 3000);

    return () => clearInterval(interval);
  }, [contentArrayThree]);

  const handleJoinWaitList = () => {
    setShowWaitlist(true);
  };

  const handleConfetti = () => {
    setShowWaitlist(false);
    setShowConfetti(true);
  };

  const closeJoinWaitlist = () => {
    setShowWaitlist(false);
  };

  const handleCloseCofetti = () => {
    setShowConfetti(false);
  };

  const joinButtonStyle = {
    backgroundColor: isHovered ? "#80E381" : "#00A603",
    color: "white",
    padding: "10px 30px",
    borderRadius: "30px",
    border: "none",
    marginTop: "30px",
    marginBottom: "5px",
    transition: "background-color 0.3s ease",
  };

  const animationDuration = 700;

  return (
    <Container>
      <Navbar />
      <HeroContainer>
        {showWailist ? (
          <JoinWailist
            closeModal={() => setShowWaitlist(false)}
            showCongrats={showConfetti}
            handleClick={handleConfetti}
            handleCloseJoinWaitList={closeJoinWaitlist}
          />
        ) : null}
        {showConfetti === true ? (
          <ConfettiPage handleCloseCofetti={handleCloseCofetti} />
        ) : null}

        <HeroContent>
          <EntranceAnimationY duration={1} delay={1}>
            <HeroTitle>
              {t("Discover a better pay by bank experience", {
                lng: currentLocale,
              })}
              {t("", { lng: currentLocale })}
            </HeroTitle>
          </EntranceAnimationY>
          <EntranceAnimationY duration={1} delay={1.3}>
            <HeroParagraph>
              {/* <HeroText className="flipX"> */}
              {t(
                "Our pay with bank experience solves the two largest customer concerns for ",
                {
                  lng: currentLocale,
                }
              )}{" "}
              {t(
                "providers and merchants processing in the US - security and rewards. ",
                {
                  lng: currentLocale,
                }
              )}
              {t(
                "FiPay offers unified tokenization and rewards similar to credit cards.",
                {
                  lng: currentLocale,
                }
              )}
            </HeroParagraph>
          </EntranceAnimationY>

          <HeroSmallScreen>
            {t("Discover a better pay by bank experience", {
              lng: currentLocale,
            })}
            <br />
            {t("payments with AI", { lng: currentLocale })}
          </HeroSmallScreen>

          <EntranceAnimationY duration={1} delay={1.6}>
            <Button
              id={""}
              type="button"
              disabled={false}
              onClick={handleJoinWaitList}
              padding={"10px 40px"}
              title={t("Join Waitlist", { lng: currentLocale })}
              green
            />
          </EntranceAnimationY>
        </HeroContent>
        <EarthRound>
          <FixtureDiv>
            <Anime
              easing="easeInOutBack"
              loop={true}
              duration={animationDuration}
              direction="reverse"
              translateX="14rem"
              delay={anime.stagger({ start: 2000, step: 100 })}
            >
              <div className={`first_div ${isShiftedOne ? "shifted" : ""}`}>
                <p className={`text-hint`}>
                  {t(contentArrayOne[contentIndexOne], { lng: currentLocale })}
                </p>
              </div>
            </Anime>

            <div className="inner-gra1">
              <img
                className="first_Img"
                src="/assets/icons/Line1.png"
                alt="/assets/icons/Line1.png"
              />
              <img
                className="secondImg"
                src="/assets/icons/Rectangle1.png"
                alt="/assets/icons/Rectangle1.png"
              />
            </div>

            <Anime
              easing="easeInOutExpo"
              loop={true}
              duration={animationDuration}
              direction="reverse"
              translateX="13rem"
              delay={anime.stagger({ start: 2000, step: 100 })}
            >
              <div className={`middle_div ${isShiftedOne ? "shifted" : ""}`}>
                <p className={`middle-hint`}>
                  {t(contentArrayTwo[contentIndexTwo], { lng: currentLocale })}
                </p>
              </div>
            </Anime>

            <div className="inner-gra2">
              <img
                className="first_Img"
                src="/assets/icons/Line1.png"
                alt="/assets/icons/Line1.png"
              />
              <img
                className="secondImg"
                src="/assets/icons/Rectangle2.png"
                alt="/assets/icons/Rectangle2.png"
              />
            </div>
            <Anime
              easing="easeInOutCubic"
              loop={true}
              duration={animationDuration}
              direction="reverse"
              translateX="14rem"
              delay={anime.stagger({ start: 2000, step: 100 })}
            >
              <div className={`third_div ${isShiftedOne ? "shifted" : ""}`}>
                <p className={`last-hint`}>
                  {t(contentArrayThree[contentIndexThree], {
                    lng: currentLocale,
                  })}
                </p>
              </div>
            </Anime>

            <div className="inner-gra3">
              <img
                className="first_Img"
                src="/assets/icons/Line1.png"
                alt="/assets/icons/Line1.png"
              />
              <img
                className="secondImg"
                src="/assets/icons/Rectangle1.png"
                alt="/assets/icons/Rectangle1.png"
              />
            </div>
          </FixtureDiv>
          <img
            src="/assets/icons/Curve.png"
            alt=""
            width={150}
            height={290}
            className="curve"
          />
          <img
            className="layer"
            src="/assets/icons/Layer_1.svg"
            alt=""
            width={250}
            height={250}
          />
        </EarthRound>
      </HeroContainer>
    </Container>
  );
};

export default Hero;
